export enum RequestStatusEnum {
  Idle = 'idle',
  Pending = 'pending',
  Fulfilled = 'fulfilled',
  Error = 'error',
}
